export const CHILD_WITHOUT_ACCOMPANIENT_ERROR_CODE = "2098";
export const INCORRECT_ERROR_CODE = "2000";
export const DEPARTURE_BEFORE_PREVIOUS_FLIGHT_MULTICITY = "2040";

export const INVALID_DATE_ERROR_CODE = "INVALID_DATE";
